<template>
  <div
    tabindex="-1"
    :aria-hidden="!isVisible"
    class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-50 tw-max-h-full tw-w-full tw-bg-[#000000]/50 tw-transition-all dark:tw-bg-[#000000]/80"
    :class="isVisible"
    :data-test-id="testId"
  >
    <div
      ref="target"
      class="tw-fixed tw-left-1/2 tw-top-1/2 tw-max-h-full tw-w-full tw--translate-x-1/2 tw--translate-y-1/2"
      :class="sizeClass"
    >
      <div
        class="tw-relative tw-rounded-lg tw-bg-white tw-shadow dark:tw-bg-light"
      >
        <div
          class="tw-max-h-[70vh] tw-overflow-y-auto"
          :class="{ 'tw-pt-0': props.hideHeader }"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { onClickOutside } from "@vueuse/core";

type Size = "sm" | "md" | "lg" | "xl" | "xxl";

export interface ModalProps {
  visible: boolean;
  testId?: string;
  headerLabel?: string;
  acceptLabel?: string;
  declineLabel?: string;
  size: Size;
  closeOnClickOutside?: boolean;
  hideHeader?: boolean;
}

const props = withDefaults(defineProps<ModalProps>(), {
  testId: "default-test-id",
  headerLabel: "Modal",
  acceptLabel: "Accept",
  declineLabel: "Decline",
  size: "md",
  closeOnClickOutside: false,
  hideHeader: false,
});

const target = ref(null);

onClickOutside(target, () => {
  if (props.closeOnClickOutside) {
    emitClose();
  }
});

const isVisible = computed(() => {
  if (props.visible) {
    return "tw-visible  tw-opacity-1";
  }

  return "tw-invisible  tw-opacity-0";
});

const sizes = {
  sm: "tw-max-w-1xl",
  md: "tw-max-w-2xl",
  lg: "tw-max-w-3xl",
  xl: "tw-max-w-4xl",
  xxl: "tw-max-w-5xl",
};

const sizeClass = computed(() => {
  return [sizes[props.size]];
});

const emit = defineEmits<{
  (event: "on-close"): void;
}>();

const emitClose = (): void => {
  emit("on-close");
};
</script>

<style scoped></style>
